export default __webpack_public_path__ + "static/media/report_generated_icon.fe75f485.svg";